import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=9144136e&scoped=true"
import script from "./change-phone.vue?vue&type=script&lang=js"
export * from "./change-phone.vue?vue&type=script&lang=js"
import style0 from "./change-phone.vue?vue&type=style&index=0&id=9144136e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9144136e",
  null
  
)

export default component.exports